const imgData_2025 = {
  the_forest_pact: {
    title: 'The Forest Pact',
    imgs: {
      full: {
        src: require('./the_forest_pact_2025_web.jpg'),
        width: 1072,
        height: 1500,
      },
      thumb: {
        src: require('./the_forest_pact_2025_thumb.jpg'),
        width: 429,
        height: 600,
      },
    },
    year: '2025',
    description:
      'Pen, markers and coloured pencils on paper. 250 x 350 mm, 2025.',
    price: 326,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/4480036272/',
    merch: [
      {
        name: 'Colouring Page - Digital printable',
        url: 'https://www.etsy.com/ie/listing/4486663827/',
        /* prettier-ignore */
        price: 5.50,
        discount: 0,
        isDigital: true,
      },
    ],
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'Continuing my illustration portfolio... This picture was inspired by my childhood stories with animal protagonists. And I also really wanted to draw a fallow deer!',
  },
  monty: {
    title: 'Monty',
    imgs: {
      full: {
        src: require('./monty_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./monty_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen on paper. 210 x 297 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story: 'A commission to create a memorial to a beloved kitten.',
  },
  octopus_bunny: {
    title: 'Octopus Bunny',
    imgs: {
      full: {
        src: require('./octopus_bunny_2025_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./octopus_bunny_2025_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2025',
    description: 'Pen and watercolour on paper. 297 x 420 mm, 2025.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'Sometimes I get funny requests to paint... like this bunny with an octopus plushie on his head.',
  },
};

export default imgData_2025;
